import { FileClient } from "clients/rest";

export type B100183ExcelRequest = Partial<{
  whtankaKbn: string;
  whtankaCdFrom: string;
  whtankaCdTo: string;
}>;

export const B100183GetExcel = (props: B100183ExcelRequest) => {
  return FileClient.get("b100183/get/excel", {
    params: props,
  });
};
